export default __webpack_public_path__ + "images/2d01c907698e137d9c0a23223ee4725d-weightlifting.jpg";